import { render, staticRenderFns } from "./ChartjsHorizontalBarChartCommitments.vue?vue&type=template&id=2fe88cd0&"
import script from "./ChartjsHorizontalBarChartCommitments.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartCommitments.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartCommitments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports